module.exports = __webpack_public_path__ + "static/img/anxun14.3c7b01dc.png";